import request from '@/service/request';

export const GetProductList = (productType: string, query: any) => {
  return request(`/v1/shaft/admin/class/ips/vn/${productType}/plans`, {
    params: { query },
  });
};

export const CreateQuote = (
  productType: string,
  productKey: string,
  planKey: string,
  data: any,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation`,
    {
      method: 'post',
      data: {
        fast_quote: data,
      },
    },
  );
};

export const QuotationConfirm = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}/state`,
    {
      method: 'put',
    },
  );
};
